import script from "./V4HomeAssignedCourseMain.vue?vue&type=script&setup=true&lang=js"
export * from "./V4HomeAssignedCourseMain.vue?vue&type=script&setup=true&lang=js"

import "./V4HomeAssignedCourseMain.vue?vue&type=style&index=0&id=8345699a&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8345699a"]])

export default __exports__